import { cx } from '@/shared/lib/cx';

import styles from './quantity-stepper.module.scss';

export type QuantityStepperProps = {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
  label: string;
  /** Names the buttons ("Уменьшить количество: Леггинсы…"). */
  itemName?: string | undefined;
  className?: string | undefined;
};

export function QuantityStepper({
  value,
  onChange,
  min = 1,
  max = 99,
  disabled = false,
  label,
  itemName,
  className,
}: QuantityStepperProps) {
  const atMin = value <= min;
  const atMax = value >= max;
  const suffix = itemName ? `: ${itemName}` : '';
  return (
    <fieldset className={cx(styles.root, className)} aria-label={label}>
      <button
        type="button"
        className={styles.button}
        aria-label={`Уменьшить количество${suffix}`}
        aria-disabled={atMin || disabled || undefined}
        data-dim={atMin || undefined}
        onClick={() => {
          if (!atMin && !disabled) onChange(value - 1);
        }}
      >
        −
      </button>
      <span className={styles.value} aria-live="polite">
        {value}
      </span>
      <button
        type="button"
        className={styles.button}
        aria-label={`Увеличить количество${suffix}`}
        aria-disabled={atMax || disabled || undefined}
        data-dim={atMax || undefined}
        onClick={() => {
          if (!atMax && !disabled) onChange(value + 1);
        }}
      >
        +
      </button>
    </fieldset>
  );
}
